import { render } from "./index.vue?vue&type=template&id=64e0fc31"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/molecules/data-table/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64e0fc31"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64e0fc31', __exports__)) {
    api.reload('64e0fc31', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=64e0fc31", () => {
    api.rerender('64e0fc31', render)
  })

}


export default __exports__